import { render, staticRenderFns } from "./RepairTypeList.vue?vue&type=template&id=51ada70a"
import script from "./RepairTypeList.vue?vue&type=script&lang=js"
export * from "./RepairTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports